import localStorage from 'store';

export default {
  namespaced: true,
  state: {
    adminInfo: {},
    permissions: [],
    menus: []
  },
  getters: {
    adminInfo: state => {
      if(!state.adminInfo) {
        try {
          const adminInfo = localStorage.getItem('admin.adminInfo');
          console.log('adminInfo:' + adminInfo);
          state.adminInfo = JSON.parse(adminInfo);
          state.adminInfo = state.adminInfo ? state.adminInfo : {};
        } catch(e) {
          console.error(e);
        }
      }
    },
    permissions: state => {
      if(!state.permissions) {
        try {
          const permissions = localStorage.getItem('admin.permissions');
          state.permissions = JSON.parse(permissions);
          state.permissions = state.permissions ? state.permissions : [];
        } catch(e) {
          console.error(e);
        }
      }
    },
    menus: state => {
      if(!state.menus) {
        try {
          const menus = localStorage.getItem('admin.menus');
          state.menus = JSON.parse(menus);
          state.menus = state.menus ? state.menus : [];
        } catch(e) {
          console.error(e);
        }
      }
    }
  },
  mutations: {
    setAdminInfo(state, adminInfo) {
      state.adminInfo = adminInfo;
      localStorage.set('admin.adminInfo', JSON.stringify(adminInfo));
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
      localStorage.set('admin.permissions', JSON.stringify(permissions));
    },
    setMenus(state, menus) {
      state.menus = menus;
      localStorage.set('admin.menus', JSON.stringify(menus));
    },
  }
}
